var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "binSlider" }, [
    _c(
      "div",
      { staticClass: "binSlider__custom-marks" },
      [
        _c("div", { staticClass: "binSlider__single-mark" }, [
          _c("img", {
            attrs: { src: _vm.getBinAssetPath("dustbin-1.svg", "icons") }
          }),
          _vm._v("\n\t\t\t" + _vm._s(_vm.marks.min) + "\n\t\t")
        ]),
        _vm._v(" "),
        _c("vue-slider", {
          key: _vm.updater,
          staticClass: "binSlider__wrapper",
          attrs: {
            width: "100%",
            "enable-cross": false,
            tooltip: "always",
            min: _vm.min,
            max: _vm.max,
            "event-type": _vm.isMobile || _vm.isTablet ? "touch" : "mouse",
            interval: _vm.interval
          },
          scopedSlots: _vm._u([
            {
              key: "dot",
              fn: function() {
                return [_c("div", { staticClass: "binSlider__dot" })]
              },
              proxy: true
            },
            {
              key: "tooltip",
              fn: function(ref) {
                var value = ref.value
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-top"
                    },
                    [
                      _c("div", { staticClass: "binSlider__custom-tooltip" }, [
                        _c(
                          "div",
                          { staticClass: "binSlider__custom-tooltip--value" },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.tooltipValue(value)) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "binSlider__single-mark" }, [
          _c("img", {
            attrs: { src: _vm.getBinAssetPath("dustbin-3.svg", "icons") }
          }),
          _vm._v("\n\t\t\t" + _vm._s(_vm.marks.max) + "\n\t\t")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }